import script from "./PelBorrowAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./PelBorrowAmount.vue?vue&type=script&setup=true&lang=ts"

import "./PelBorrowAmount.vue?vue&type=style&index=0&id=468df44c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-468df44c"]])

export default __exports__